import { render, staticRenderFns } from "./mandala-report.view.vue?vue&type=template&id=45f632b6&scoped=true&"
import script from "./mandala-report.view.vue?vue&type=script&lang=ts&"
export * from "./mandala-report.view.vue?vue&type=script&lang=ts&"
import style0 from "./mandala-report.view.vue?vue&type=style&index=0&id=45f632b6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f632b6",
  null
  
)

export default component.exports